import _ from 'lodash';
import { iterateObject } from 'relevant-shared/misc/misc';
import { isMongoIdLike } from 'relevant-shared/misc/details/diffFns';

const cloneWithUnsavedBidParams = (object, dirtyBidParamSet) => {
	const copy = _.cloneDeep(object);
	const dirty = [...dirtyBidParamSet];
	if (!dirty.length) {
		return copy; // No open bid parameters
	}
	const dstIds = _.uniq(dirty.map((editor) => editor.getDstObj().id));
	const idToObj = {};
	iterateObject(copy, ({ value }) => {
		const { _id } = value || {};
		if (_.isString(_id) && dstIds.includes(_id) && isMongoIdLike(_id)) {
			if (idToObj[_id]) {
				throw Error('Same Id twice?');
			}
			idToObj[_id] = value;
		}
	});
	if (_.keys(idToObj).length !== dstIds.length) {
		throw Error('BidParamEdit open for object not in publisher!?');
	}
	dirty.forEach((editor) => {
		const tempObj = idToObj[editor.getDstObj().id];
		editor.applyChanges(tempObj);
	});
	return copy;
};

export {
	cloneWithUnsavedBidParams,
};
